// extracted by mini-css-extract-plugin
export default {"container":"_3bZSX","close":"_1qU0a","showCloseOnHover":"_2eshN"};